/* eslint-disable */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import NoData from "../svgIcons/NoData";
import Spinner from "../Spinner/Spinner";
import DailyReports from "./DailyReports";
import {
  checkBillingCycleAction,
  getBillingCycleAction,
} from "../../actions/billingCycle";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import ReportPdfGenerator from "./ReportPdfGenerator";
import ProgressButton from "react-progress-button";
const BillingCycleDetails = () => {
  const { id } = useParams();
  const history = useHistory();
  const dispatch = useDispatch();
  const user = JSON.parse(localStorage.getItem("profile"));
  const [buttonStatus, setButtonStatus] = useState();
  const { billingCycle } = useSelector((state) => state.billingCycle);

  const payments = billingCycle?.paymentIds;
  const isLoading = useSelector((state) => state.product.isLoading);
  const handleCheckReport = (e) => {
    e.preventDefault();
    const isConfirmed = window.confirm(
      "Are you sure you want to process this action?"
    );

    if (isConfirmed) {
      dispatch(checkBillingCycleAction(id, setButtonStatus));
    }
  };
  useEffect(() => {
    dispatch(getBillingCycleAction(id));
  }, [dispatch, id]);

  if (!user) {
    history.push("/login");
  }

  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
        }}
      >
        <Spinner />
      </div>
    );
  }

  if (payments?.length === 0) {
    return (
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexDirection: "column",
          paddingTop: "20px",
          margin: "80px",
        }}
      >
        <NoData />
        <p style={{ padding: "40px", color: "gray", textAlign: "center" }}>
          No Payments yet.
        </p>
      </div>
    );
  }

  return (
    <div>
      <h1 style={{ textAlign: "center", marginTop: "2%" }}> Report Details</h1>
      {user?.result?.role == "admin" && (
        <h3 style={{ textAlign: "center", marginTop: "2%" }}>
          Assistant : {billingCycle?.assistant?.name}
        </h3>
      )}
      <div style={{ marginTop: "7%" }}>
        <DailyReports payments={payments} />
        {user?.result?.role == "assistant" && (
          <ReportPdfGenerator
            payments={billingCycle?.paymentIds}
            name={user?.resut?.name}
            billingCycle={billingCycle}
          />
        )}
        {user?.result?.role == "admin" && (
          <ProgressButton
            onClick={(e) => handleCheckReport(e)}
            style={{ width: "50%", marginLeft: "25%" }}
            state={billingCycle.checked ? "disabled" : buttonStatus}
          >
            Approve
          </ProgressButton>
        )}
      </div>
    </div>
  );
};

export default BillingCycleDetails;
